// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_URL } from "constants/api";

// Define a service using a base URL and expected endpoints
export const homeApi = createApi({
  reducerPath: "home",
  baseQuery: fetchBaseQuery({
    baseUrl: API_URL,
  }),
  endpoints: (builder) => ({
    getNetworkInfo: builder.query<any, string>({
      query: (v) => `overview/${v}`,
    }),
    getTxsChart: builder.query<any, string>({
      query: (type) => `overview/txs_chart/latest?type=${type}`,
    }),
    getStats: builder.query<any, string>({
      query: () => `overview/stats`,
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetNetworkInfoQuery, useGetTxsChartQuery, useGetStatsQuery } =
  homeApi;
